<template>
  <div>
    <px-view-header title="Cadastro de cotação"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loadingForm">
      <px-circular-loading/>
    </div>

    <v-stepper class="elevation-1 rounded-card" v-if="!loadingForm" v-model="currentStep" vertical>

      <v-stepper-step :complete="currentStep > 1" step="1">
        Dados básicos
      </v-stepper-step>
      <v-stepper-content step="1">
        <px-cadastro-cotacao-dados-basicos :cotacao="cotacao"
                                           @ready="next"
                                           @cancel="onClickCancelar"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 2" step="2">Produtos</v-stepper-step>
      <v-stepper-content step="2">
        <px-cadastro-cotacao-produtos-table :cotacao="cotacao"
                                            @next="next"
                                            @savedraft="saveDraft"
                                            @previous="previous"/>
      </v-stepper-content>

      <v-stepper-step :complete="currentStep > 3" step="3">Fornecedores</v-stepper-step>
      <v-stepper-content step="3">
        <px-cadastro-cotacao-fornecedores v-if="currentStep === 3"
                                          :cotacao="cotacao"
                                          @resetfornecedor="resetFornecedor"/>
        <div class="button-div">
          <v-btn color="primary"
                 class="rounded-tag-small normal-btn-text elevation-0"
                 :loading="loading"
                 :disabled="!cotacao.fornecedores.length"
                 @click="enviarCotacao">
            Enviar
          </v-btn>
          <v-btn class="rounded-tag-small elevation-0 normal-btn-text ml-2"
                 @click="saveDraft">
            Salvar rascunho
          </v-btn>
          <v-btn class="normal-btn-text elevation-0"
                 text
                 :disabled="loading"
                 @click="previous">
            Voltar
          </v-btn>
        </div>
      </v-stepper-content>
    </v-stepper>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>
<script>
import CompradorService from '@/api/comprador-service';
import { FinalidadeCompra, SituacaoCotacao } from 'px-business-components';
import CotacaoService from '../cotacao-service';
import CadastroCotacaoDadosBasicos from './CadastroCotacaoDadosBasicos.vue';
import CadastroCotacaoFornecedores from './fornecedores/CadastroCotacaoFornecedores.vue';
import CadastroCotacaoProdutosTable from './produtos/CadastroCotacaoProdutosTable.vue';

export default {
  data() {
    return {
      // todo: verificar se será necessário usar isso
      startedFornecedor: false,
      isRascunho: this.$route.params.isRascunho,
      isCopy: this.$route.params.isCopy,
      idCotacao: this.$route.params.id,
      loadingForm: false,
      loading: false,
      formDirty: true,
      cotacao: {
        comprador: null,
        compradorEntrega: null,
        tipoFrete: null,
        prazoEntrega: null,
        projeto: null,
        centroCusto: null,
        validade: null,
        formaPagamento: null,
        prazoPagamento: null,
        observacao: null,
        observacaoInterna: null,
        finalidadeCompra: FinalidadeCompra.keys.USO_CONSUMO.key,
        tipoCotacao: 'COTACAO_ABERTA',
        situacao: 'ABERTA',
        arquivos: [],
        produtos: [],
        fornecedores: [],
      },
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Cotações',
          to: '/cotacoes',
        },
        { text: 'Cadastro de cotação' },
      ],
      currentStep: 1,
    };
  },
  computed: {
    confirmMessage() {
      return this.isRascunho ? 'Você deseja atualizar o rascunho?' : 'Você deseja salvar a cotação como rascunho?';
    },
  },
  methods: {
    next() {
      this.currentStep = this.currentStep + 1;
    },
    previous() {
      this.currentStep = this.currentStep - 1;
    },
    buildCotacaoBody() {
      const cotacao = { ...this.cotacao };
      cotacao.situacao = SituacaoCotacao.keys.ABERTA.key;
      cotacao.produtos = cotacao.produtos.map(produto => ({
        ...produto,
        situacao: SituacaoCotacao.keys.ABERTA.key,
      }));
      return cotacao;
    },
    buildCotacaoDraft() {
      const cotacao = { ...this.cotacao };
      cotacao.situacao = SituacaoCotacao.keys.RASCUNHO.key;
      cotacao.projeto = cotacao.projeto || null;
      cotacao.centroCusto = cotacao.centroCusto || null;
      cotacao.formaPagamento = cotacao.formaPagamento || null;
      cotacao.prazoPagamento = cotacao.prazoPagamento || null;
      cotacao.produtos = cotacao.produtos
        .filter(produto => !!produto.unidadeMedida.id)
        .map(produto => ({
          ...produto,
          situacao: SituacaoCotacao.keys.RASCUNHO.key,
        }));
      return cotacao;
    },
    onClickBack() {
      this.$refs.confirm.open(this.confirmMessage,
        'O rascunho ficara disponível na aba RASCUNHOS e TODAS na listagem de cotações.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            this.$router.push({ name: 'main.cotacoes' });
            return;
          }
          this.saveDraft();
        });
    },
    onClickCancelar() {
      this.$router.push({ name: 'main.cotacoes' });
    },
    resetFornecedor() {
      this.cotacao.fornecedores = [];
    },
    createFromRascunho(data) {
      const cotacao = { ...data };
      cotacao.produtos = cotacao.produtos.map(produto => ({
        ...produto,
        quantidade: produto.quantidade,
      }));
      return cotacao;
    },
    createFromCopy(data) {
      const copia = {};
      Object.keys(this.cotacao)
        .forEach((key) => {
          copia[key] = data[key];
        });
      copia.situacao = SituacaoCotacao.keys.ABERTA.key;
      copia.prazoEntrega = null;
      copia.validade = null;
      copia.produtos = copia.produtos.map(p => ({
        ...p,
        id: undefined,
        responsavel: undefined,
        quantidade: p.quantidade,
        requisicaoProduto: undefined,
        situacao: undefined,
        $$hasFileLoading: false,
      }));
      return copia;
    },
    create(data) {
      if (this.isRascunho) {
        this.cotacao = this.createFromRascunho(data);
      }
      if (this.isCopy) {
        this.cotacao = this.createFromCopy(data);
      }
    },
    getCotacao() {
      this.loadingForm = true;
      return CotacaoService.getCotacao(this.idCotacao)
        .then((response) => {
          this.create(response.data);
          return this.getComprador();
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    enviarCotacao() {
      this.loading = true;
      CotacaoService.save(this.buildCotacaoBody())
        .then(() => {
          this.$toast('Cotação enviada com sucesso', { color: 'success' });
          this.$router.push({ name: 'main.cotacoes' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveDraft() {
      this.loading = true;
      CotacaoService.saveRascunho(this.buildCotacaoDraft())
        .then(() => {
          this.$toast('Rascunho salvo com sucesso', { color: 'success' });
          this.$router.push({ name: 'main.cotacoes' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getComprador() {
      return CompradorService.getCompradorById(this.cotacao.comprador.id)
        .then(({ data }) => {
          this.cotacao.comprador = data;
        });
    },
    getCompradorDefaultFaturamento() {
      return CompradorService.getDefaultFaturamento()
        .then((response) => {
          this.cotacao.comprador = response.data;
        });
    },
    getCompradorDefaultEntrega() {
      return CompradorService.getDefaultEntrega()
        .then((response) => {
          this.cotacao.compradorEntrega = response.data;
        });
    },
    beforeWindowUnload(e) {
      if (this.formDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
  },
  watch: {
    currentStep(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.startedFornecedor = newValue === 3;
    },
  },
  components: {
    pxCadastroCotacaoDadosBasicos: CadastroCotacaoDadosBasicos,
    // pxCadastroCotacaoProdutos: CadastroCotacaoProdutos,
    pxCadastroCotacaoProdutosTable: CadastroCotacaoProdutosTable,
    pxCadastroCotacaoFornecedores: CadastroCotacaoFornecedores,
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  mounted() {
    if (this.idCotacao) {
      this.getCotacao();
      return;
    }

    this.loadingForm = true;
    Promise.all([
      this.getCompradorDefaultEntrega(),
      this.getCompradorDefaultFaturamento(),
    ])
      .then(() => {
        this.loadingForm = false;
      });
  },
};
</script>
<style scoped>
.button-div {
  align-self: auto;
  margin-bottom: 2px;
}
</style>
